import { useEffect, useState, useCallback } from "react";
import { Film, Images } from "lucide-react";
import { toast } from "sonner";
import api, { fileUrl, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Media() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/media");
    setItems(data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const downloadAssets = async (p) => {
    try {
      const res = await api.get(`/admin/products/${p.id}/assets`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/zip" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `cleartile-${p.id}-assets.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Downloading product assets (photos + video)");
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-extrabold flex items-center gap-2"><Film className="h-6 w-6 text-primary" /> Media Assets</h1>
        <p className="text-muted-foreground text-sm font-medium">Download photos and videos of approved products for social media.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {items.map((p) => (
          <div key={p.id} data-testid={`media-card-${p.id}`} className="bg-card border rounded-2xl overflow-hidden">
            <div className="aspect-square bg-slate-900">
              <img src={fileUrl(p.catalogue_image)} alt={p.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div className="font-heading font-bold text-sm line-clamp-1">{p.title}</div>
                <span className="text-[11px] text-muted-foreground">{p.city}</span>
              </div>
              <Button size="sm" variant="secondary" onClick={() => downloadAssets(p)} data-testid={`download-assets-${p.id}`} className="w-full gap-1.5 font-semibold">
                <Images className="h-3.5 w-3.5" /> Download Assets (photos + video)
              </Button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-12 text-muted-foreground font-semibold">No approved products yet.</div>}
      </div>
    </div>
  );
}
